import { Injectable } from '@angular/core';
import {
  Router, Resolve, ActivatedRouteSnapshot
}                                 from '@angular/router';
import { DataService } from 'app/data.service';
import { Observable, of, EMPTY }  from 'rxjs';
import { mergeMap, take, tap }         from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PropertyResolverService implements Resolve<any>{

  constructor( private neproseService: DataService, private router: Router ) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> | Observable<never>{
    return this.neproseService.getAdvertisement(route.paramMap.get('id')).pipe(
      take(1),
      mergeMap(propertyAd=> {
        if (propertyAd) {
          if(propertyAd.propertyAd){
            return of(propertyAd);
          }else{
            this.router.navigate(['404']);
          }
        } else {
          this.router.navigate(['404']);
        }
      })
    )
  }

}
